// OrdersHubPage — Orders, trade history, journal, analytics, achievements, certificates

import { HubLayout } from './HubLayout';

export function OrdersHubPage() {
  return (
    <HubLayout
      title="Orders & Activity"
      testIdRoot="hub-orders"
      hero={{
        title: 'Your activity',
        subtitle: 'Trades, journal, analytics, achievements',
        emoji: '📊',
        gradient: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)',
        stats: [
          { label: 'Open trades', value: '3',     sub: 'positions' },
          { label: 'Today P&L',   value: '+$842',  sub: '3 trades',  color: '#34C759' },
          { label: 'Win rate',    value: '64%',    sub: '30-day' },
        ],
      }}
      quickActions={[
        { to: '/portal/orders',      label: 'Orders',      icon: '📋', testId: 'hub-orders-qa-orders' },
        { to: '/portal/trades',      label: 'History',     icon: '📜', testId: 'hub-orders-qa-history' },
        { to: '/portal/analytics',   label: 'Analytics',   icon: '📊', testId: 'hub-orders-qa-analytics' },
      ]}
      sections={[
        {
          title: 'Trading Activity',
          items: [
            { to: '/portal/orders',      icon: '📋', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Open orders',        sub: '3 active positions' },
            { to: '/portal/trades',      icon: '📜', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'Trade history',      sub: 'Closed positions · all time' },
            { to: '/portal/trade/trade-001', icon: '🔎', iconBg: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)', label: 'Trade detail',        sub: 'Single trade view' },
            { to: '/portal/journal',     icon: '📓', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Trade journal',      sub: '30-day heatmap + notes' },
            { to: '/portal/analytics',   icon: '📊', iconBg: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)', label: 'Analytics',          sub: 'P&L, win rate, drawdown' },
          ],
        },
        {
          title: 'Performance',
          items: [
            { to: '/portal/leaderboard', icon: '🏅', iconBg: 'linear-gradient(135deg, #FFD60A 0%, #FF9500 100%)', label: 'Leaderboard',        sub: 'Top 100 traders this week' },
            { to: '/portal/goals',       icon: '🎯', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)', label: 'Goals',              sub: 'Profit, consistency, days' },
            { to: '/portal/achievements',icon: '🏆', iconBg: 'linear-gradient(135deg, #FFD60A 0%, #FF9500 100%)', label: 'Achievements',       sub: '23 unlocked · 7 locked' },
            { to: '/portal/achievement/first-payout', icon: '⭐', iconBg: 'linear-gradient(135deg, #FF9500 0%, #FFD60A 100%)', label: 'Achievement detail', sub: 'First payout' },
            { to: '/portal/certificates', icon: '📜', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Certificates',       sub: '5 earned · trophy case' },
            { to: '/portal/showcase',     icon: '🌟', iconBg: 'linear-gradient(135deg, #5856D6 0%, #FF2D55 100%)', label: 'Public showcase',    sub: 'Your achievements' },
          ],
        },
        {
          title: 'Social & Network',
          items: [
            { to: '/portal/feed',         icon: '🌍', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Social feed',         sub: 'Posts & copy-trade' },
            { to: '/portal/trader/marcus-j', icon: '👤', iconBg: 'linear-gradient(135deg, #FF2D55 0%, #5856D6 100%)', label: 'Trader profile',   sub: 'Public profile view' },
          ],
        },
      ]}
    />
  );
}
